import React from "react";
import { useParams } from "react-router-dom";
import GenericDashboard from "../GenericDashboard/GenericDashboard";
import FormConfig from "../../Config/FormConfig.js";
import APIService from "../../Service/APIService";
import CustomHeader from "../CustomHeader/CustomHeader";
import { Button, Input, message, Row, Col, Upload, DatePicker } from "antd";
import * as yup from "yup";
import { Formik } from "formik";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { UploadOutlined } from "@ant-design/icons";
import { colors } from "../../theme/colors.js";

const EditProductLog = (props) => {
  const { orderData } = props;
  const [initialValues, setInitialValues] = React.useState(null);

  const generateInitialValues = (fieldVal, data = null) => {
    let obj = {};
    console.log("Data: ", data);
    if (!data) {
      for (const cur of fieldVal) {
        obj[cur.backendName] = null;
      }
    } else {
      for (const cur of fieldVal) {
        obj[cur.backendName] =
          cur.backendName in data ? data[cur.backendName] : null;
      }
    }
    console.log("Initial Values:", obj);
    return obj;
  };

  const generateFieldsArray = async (data) => {
    const fields = FormConfig.EditAccountProductLog;
    const val = generateInitialValues(fields, data);
    console.log("Fields: ", fields);
    console.log("Val: ", val);
    val["ApplicationDate"] =
      data["ApplicationDate"] === null ? null : dayjs(data["ApplicationDate"]);
    // if(val["ApplicationNumber"] === null) {
    //   setDisableAppNumber(false);
    // }
    if (val["TissueTrackingFileBlobName"]) {
      console.log("Tissue Tracking File: ", val["TissueTrackingFile"]);
      setUploadFileList([
        { name: val["TissueTrackingFileName"], status: "done", uid: "1" },
      ]);
      setFileName(val["TissueTrackingFileName"]);
      setTissueTrackingFileBlobName(val["TissueTrackingFileBlobName"]);
    }
    console.log("val", val);
    setInitialValues(val);
    return fields;
  };

  const submitHandler = (values) => {
    console.log("Submit Handler: ", values);
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update the product log!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["successColor"],
      cancelButtonColor: colors["failureColor"],
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        values.isFileUpdated = isFileUpdated;
        const stringifiedPostObj = JSON.stringify(values);
        const formData = new FormData();
        formData.append("file", tissueTracking);
        formData.append("data", stringifiedPostObj);

        const apiServe = new APIService();
        // const response = await apiServe.updateDataToBackend(values, "updateinvoiceproducts");
        const response = await apiServe.addFileDataToBackend(
          formData,
          "updateinvoiceproducts?type=EditProductLog",
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire(
            "Updated!",
            "Product log has been updated.",
            "success"
          ).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire("Error!", "Product log could not be updated.", "error");
        }
      }
    });
  };

  React.useEffect(() => {
    console.log("Edit Product Log");
    console.log("Order Data: ", orderData);
    let val = generateFieldsArray(orderData);
    // setValidationSchema(yup.object().shape(generateValidationSchema(val)));
  }, []);

  const [tissueTracking, setTissueTracking] = React.useState(null);
  const [uploadFileList, setUploadFileList] = React.useState([]);
  const [isFileUpdated, setIsFileUpdated] = React.useState(false);
  const [fileName, setFileName] = React.useState(null);
  const [tissueTrackingFileBlobName, setTissueTrackingFileBlobName] =
    React.useState(null);

  const handleFile = async ({ file, onSuccess }) => {
    if (file.size > 4194304) {
      message.error("File size should be less than 4MB");
      setFileName(null);
      setTissueTracking(null);
      setUploadFileList([]);
      return;
    }
    setIsFileUpdated(true);
    setUploadFileList([{ name: file.name, status: "done", uid: "1" }]);
    setTissueTracking(file);
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const downloadFile = async () => {
    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(tissueTrackingFileBlobName);

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }
    // download the file from Azure Blob Storage
    const link = document.createElement("a");
    link.href = sasUrl;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // console.log("Download File: ", tissueTracking);
    // const url = window.URL.createObjectURL(tissueTracking);

    // // Create a link element and trigger the download
    // const link = document.createElement("a");
    // link.href = url;
    // link.setAttribute("download", fileName); // Set the file name
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    // action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    accept: [".pdf"],
    // disabled: !isEditable,
    fileList: uploadFileList,
    customRequest: handleFile,
    onPreview: downloadFile,
    onRemove: (file) => {
      setTissueTracking(null);
      setUploadFileList([]);
      setFileName(null);
    },
    onChange(info) {
      console.log("File Info: ", info);
      const { status } = info.file;
      // console.log("Status: ", status);
      if (status !== "uploading") {
        // console.log(info.file, info.fileList);
      }
      if (status === "done") {
        // setIvrReport(info.file.originFileObj);
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  return (
    <div>
      {initialValues && uploadProps && (
        <Formik
          onSubmit={submitHandler}
          initialValues={initialValues}
        >
          {(formik) => (
            <form onSubmit={formik.handleSubmit}>
              <Row gutter={16}>
                <Col span={8} style={{ width: "100%" }}>
                  <label className="form-label">Tissue ID</label>
                  <Input
                    name="TissueID"
                    value={formik.values.TissueID}
                    disabled
                  />
                </Col>
                <Col span={8} style={{ width: "100%" }}>
                  <label className="form-label">Product Code</label>
                  <Input
                    name="ProductCode"
                    value={formik.values.ProductCode}
                    disabled
                  />
                </Col>
                <Col span={8} style={{ width: "100%" }}>
                  <label className="form-label">Application Number</label>
                  <Input
                    name="ApplicationNumber"
                    value={formik.values.ApplicationNumber}
                    onChange={formik.handleChange}
                  />
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8} style={{ width: "100%" }}>
                  <label className="form-label">Application Date</label>
                  <DatePicker
                    format="MM-DD-YYYY"
                    onBlur={() => formik.setFieldTouched("ApplicationDate")}
                    title={formik.values["ApplicationDate"]}
                    value={formik.values.ApplicationDate}
                    onChange={(date, dateString) =>
                      formik.setFieldValue("ApplicationDate", date)
                    }
                    style={{ width: "100%" }}
                    disabledDate={(current) =>
                      current && current > dayjs().endOf("day")
                    }
                  />
                </Col>
                <Col span={8} style={{ width: "100%" }}>
                  <label className="form-label">Patient First Name</label>
                  <Input
                    name="PatientFirstName"
                    value={formik.values.PatientFirstName}
                    onChange={formik.handleChange}
                  />
                  {formik.errors["PatientFirstName"] &&
                  formik.touched["PatientFirstName"] ? (
                    <div
                      style={{
                        color: "red",
                        paddingTop: "4px",
                        fontSize: "12px",
                      }}
                    >
                      {formik.errors["PatientFirstName"]}
                    </div>
                  ) : null}
                </Col>
                <Col span={8} style={{ width: "100%" }}>
                  <label className="form-label">Patient Last Name</label>
                  <Input
                    name="PatientLastName"
                    value={formik.values.PatientLastName}
                    onChange={formik.handleChange}
                  />
                  {formik.errors["PatientLastName"] &&
                  formik.touched["PatientLastName"] ? (
                    <div
                      style={{
                        color: "red",
                        paddingTop: "4px",
                        fontSize: "12px",
                      }}
                    >
                      {formik.errors["PatientLastName"]}
                    </div>
                  ) : null}
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8} style={{ width: "100%" }}>
                  <label className="form-label">Claim Number</label>
                  <Input
                    name="ClaimNumber"
                    value={formik.values.ClaimNumber}
                    onChange={formik.handleChange}
                  />
                  {formik.errors["ClaimNumber"] &&
                  formik.touched["ClaimNumber"] ? (
                    <div
                      style={{
                        color: "red",
                        paddingTop: "4px",
                        fontSize: "12px",
                      }}
                    >
                      {formik.errors["ClaimNumber"]}
                    </div>
                  ) : null}
                </Col>
                <Col span={8} style={{ width: "100%" }}>
                  <label className="form-label">Upload Tissue Tracking</label>
                  <Upload {...uploadProps}>
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                </Col>
              </Row>
              <Button
                type="primary"
                onClick={() => formik.handleSubmit()}
                style={{ background: "#27a907", marginTop: "10px" }}
              >
                Update
              </Button>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default EditProductLog;
